import React, { useState } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import CXAdminDashboard from "./CXAdminDashboard";
import ESSDashboard from "./ESSDashboard";
import HRAdminDashboard from "./HRAdminDashboard";
import PredictDashboard from "./PredictDashboard";

const DashboardPage = (props) => {
  const [ActiveTabName, setActiveTabName] = useState("EMPLOYEE"); // values: "EMPLOYEE" || "RECRUITER" || "CXADMIN" || "PREDICTION"
  const [TabIds] = useState([
    "recruiter",
    "employee",
    "cx-admin",
    "prediction",
  ]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const transformIndicator = (Index, DashboardId) => {
    // removing active class list from all nodes first
    TabIds.map((TabId) => {
      document.getElementById(TabId)?.classList.remove("active-nav-node");
    });

    // setting active tab name and adding active class name to the selected link element
    if (Index === 0) {
      setActiveTabName("EMPLOYEE");

      document.getElementById("animated-indicator").style.transform = "none";
      document.getElementById("employee").classList.add("active-nav-node");
    } else if (Index === 1) {
      if (DashboardId === "cx-admin") {
        setActiveTabName("CXADMIN");
        document.getElementById("animated-indicator").style.transform =
          "translateX(134px)";
        document.getElementById("cx-admin").classList.add("active-nav-node");
      } else {
        setActiveTabName("RECRUITER");

        document.getElementById("animated-indicator").style.transform =
          "translateX(134px)";
        document.getElementById("recruiter").classList.add("active-nav-node");
      }
    } else if (Index === 2) {
      if (DashboardId === "cx-admin") {
        setActiveTabName("CXADMIN");

        document.getElementById("animated-indicator").style.transform =
          "translateX(264px)";
        document.getElementById("cx-admin").classList.add("active-nav-node");
      } else {
        setActiveTabName("PREDICTION");

        document.getElementById("animated-indicator").style.transform =
          "translateX(264px)";
        document.getElementById("prediction").classList.add("active-nav-node");
      }
    } else if (Index === 3) {
      setActiveTabName("CXADMIN");

      document.getElementById("animated-indicator").style.transform =
        "translateX(403px)";
      document.getElementById("cx-admin").classList.add("active-nav-node");
    }
  };

  // Displaying the related dashboard element based on ActiveTabName
  // state which is set every time a tab is clicked
  const handleDashboardToDisplay = () => {
    if (ActiveTabName === "EMPLOYEE") {
      return <ESSDashboard LangData={props.LangData} />;
    } else if (ActiveTabName === "RECRUITER") {
      return (
        <>
          {props.IsSuperAdmin || props.IsHRAdmin || props.IsMSS ? (
            <HRAdminDashboard LangData={props.LangData} />
          ) : null}
        </>
      );
    } else if (ActiveTabName === "CXADMIN") {
      return (
        <>
          {props.IsCXAdmin || props.IsSuperAdmin ? (
            <CXAdminDashboard LangData={props.LangData} />
          ) : null}
        </>
      );
    } else {
      return <PredictDashboard LangData={props.LangData} />;
    }
  };

  return (
    <div className="main-content">
      <ContentHeader PageName={translateText("dashboard")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("dashboard")}</p>
        </div>
      </div>
      {props.IsHRAdmin || props.IsSuperAdmin ? (
        <div className="nav-wrapper">
          <div className="actions navigator-tabs navigator-sm">
            <span id="animated-indicator"></span>
            <a
              className="active-nav-node"
              onClick={() => transformIndicator(0)}
              id="employee"
            >
              <p>{translateText("employee")}</p>
            </a>
            <a onClick={() => transformIndicator(1)} id="recruiter">
              <p>{translateText("recruiter")}</p>
            </a>
            <a onClick={() => transformIndicator(2)} id="prediction">
              <p>{translateText("prediction")}</p>
            </a>
            {(props.IsSuperAdmin || props.IsCXAdmin) && (
              <a onClick={() => transformIndicator(3)} id="cx-admin">
                <p>CX Admin</p>
              </a>
            )}
          </div>
        </div>
      ) : (
        <>
          {props.IsMSS && props.IsCXAdmin ? (
            <div className="nav-wrapper">
              <div className="actions navigator-tabs navigator-sm">
                <span id="animated-indicator"></span>
                <a
                  className="active-nav-node"
                  onClick={() => transformIndicator(0)}
                  id="employee"
                >
                  <p>{translateText("employee")}</p>
                </a>
                <a onClick={() => transformIndicator(1)} id="recruiter">
                  <p>{translateText("recruiter")}</p>
                </a>
                <a
                  onClick={() => transformIndicator(2, "cx-admin")}
                  id="cx-admin"
                >
                  <p>CX Admin</p>
                </a>
              </div>
            </div>
          ) : props.IsMSS ? (
            <div className="nav-wrapper">
              <div className="actions navigator-tabs navigator-sm">
                <span id="animated-indicator"></span>
                <a
                  className="active-nav-node"
                  onClick={() => transformIndicator(0)}
                  id="employee"
                >
                  <p>{translateText("employee")}</p>
                </a>
                <a onClick={() => transformIndicator(1)} id="recruiter">
                  <p>{translateText("recruiter")}</p>
                </a>
              </div>
            </div>
          ) : (
            <>
              {props.IsCXAdmin ? (
                <div className="nav-wrapper">
                  <div className="actions navigator-tabs navigator-sm">
                    <span id="animated-indicator"></span>
                    <a
                      className="active-nav-node"
                      onClick={() => transformIndicator(0)}
                      id="employee"
                    >
                      <p>{translateText("employee")}</p>
                    </a>
                    <a
                      onClick={() => transformIndicator(1, "cx-admin")}
                      id="cx-admin"
                    >
                      <p>CX Admin</p>
                    </a>
                  </div>
                </div>
              ) : null}
            </>
          )}
        </>
      )}
      <>{handleDashboardToDisplay()}</>
    </div>
  );
};

export default DashboardPage;
